import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import FeedbackIcon from "@mui/icons-material/Feedback";
import MailIcon from '@mui/icons-material/Mail';

const Header = () => {
  const feedbackHandler = () => {
    window.open("https://forms.gle/dPSSKTifArpH1MJaA", "_blank");
  };

  const newsHandler = () => {
    window.open("https://nasetrida.substack.com", "_blank");
  };

  return (
    <div className="header mb-5">
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Settlers v0.6
          </Typography>
          <Button
            color="inherit"
            startIcon={<FeedbackIcon />}
            onClick={feedbackHandler}
          >
            Zpětná vazba
          </Button>
          <Button
            color="inherit"
            startIcon={<MailIcon />}
            onClick={newsHandler}
            className="d-none d-md-flex ms-md-4"
          >
            Odběr novinek e-mailem
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
